export default __webpack_public_path__ + "static/media/Giro_Pagamentos_2linhas_Monocromatico_Branco.b45c03ec.png";